<template>
    <div class="login-page">
        <b-container>
            <h5 class="logo">
                <i class="fa fa-circle text-gray"/>
                Crazy Trip
                <i class="fa fa-circle text-warning"/>
            </h5>
            <Widget class="mx-auto" title="<h3 class='mt-0'>Create an account</h3>" customHeader>
                <p class="text-muted mb-0 mt fs-sm">
                    <!--<md-button slot="buttons" to="#facebook" class="md-just-icon md-simple md-white">-->
                    <!--<i class="fab fa-facebook-square"></i>-->
                    <!--</md-button>-->
                    <!--<md-button slot="buttons" to="#twitter" class="md-just-icon md-simple md-white">-->
                    <!--<i class="fab fa-twitter"></i>-->
                    <!--</md-button>-->

                    <b-button variant="danger" block @click="userSignInWithGoogle">
                        <i class="fa fa-google"/>&nbsp;&nbsp;Login with Google
                    </b-button>

                    <b-button variant="primary" block @click="userSignInWithFacebook">
                        <i class="fa fa-facebook"/>&nbsp;&nbsp;Login with Facebook
                    </b-button>
                </p>

                <br>
                <br>


                <p class="text-muted fs-sm">
                    Or Be Classical
                </p>

                <form class="mt" @submit.prevent="userSignUp">

                    <b-alert class="" variant="danger" :show="!!error">
                        {{error}}
                    </b-alert>


                    <div class="form-group">
                        <input class="form-control no-border" v-model="fullName"
                               required type="text" name="fullName" placeholder="Your full name"/>
                    </div>
                    <div class="form-group">
                        <input class="form-control no-border" v-model="email"
                               required type="text" name="username" placeholder="Email"/>
                    </div>
                    <div class="form-group">
                        <input class="form-control no-border"
                               required type="password"
                               name="password"
                               placeholder="Password"
                               v-model="password"
                               required
                        />
                    </div>
                    <div class="form-group">
                        <input class="form-control no-border"
                               v-model="confirmPassword"
                               type="password"
                               placeholder="Confirm Password"
                               required
                        />
                    </div>

                    <b-checkbox v-model="acceptTerms">I agree to the <a>terms and conditions</a>.</b-checkbox>

                    <div class="clearfix">
                        <div class="btn-toolbar float-right">

                            <b-button type="reset" size="sm" variant="default" @click="$router.push('/login')">i Already have an account</b-button>

                            <b-button type="submit" size="sm" variant="inverse">Create an Account</b-button>

                        </div>
                    </div>
                    <div class="row no-gutters mt-3">
                        <div class="col">
                            <div class="abc-checkbox">
                                <!--                                <input-->
                                <!--                                        type="checkbox"-->
                                <!--                                        id="checkbox"-->
                                <!--                                />-->
                                <!--                                <label for="checkbox" class="text-muted fs-sm">Keep me signed in</label>-->
                            </div>
                        </div>
                        <div class="col">
                            <!--                            <a class="mt-sm" href="">Trouble with account?</a>-->
                        </div>
                    </div>
                </form>
            </Widget>
        </b-container>

    </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget'

  const fb = require('@/firebaseConfig.js')
  import firebase from 'firebase'
  import UIHelpersMixins from '@/mixims/UIHelpersMixins'

  export default {
    components: {
      Widget
    },
    data ()
    {
      return {

        errorMessage: '',

        acceptTerms:     false,
        fullName:        '',
        email:           '',
        password:        '',
        confirmPassword: '',

      }
    },
    computed:   {
      comparePasswords ()
      {
        return this.password === this.confirmPassword
      },
      error ()
      {
        return this.$store.state.crazytrip.error
      },
    }, // computed
    methods:    {
      userSignInWithGoogle ()
      {
        const provider = new firebase.auth.GoogleAuthProvider()
        provider.addScope('profile')
        provider.addScope('email')

        this.$store.dispatch('userSignInWithProvider', provider)
      },
      userSignInWithFacebook ()
      {
        const provider = new firebase.auth.FacebookAuthProvider()
        provider.addScope('email')

        this.$store.dispatch('userSignInWithProvider', provider)
      },

      userSignUp ()
      {
        if (this.comparePasswords !== true)
        {
          this.$store.commit('setError', 'Passwords dont match')

          return
        }
        if (this.fullName.length < 2)
        {
          this.$store.commit('setError', 'Please enter your name')
          return
        }

        if (!this.acceptTerms)
        {
          this.$store.commit('setError', 'You need to accept the terms and conditions first')
          return
        }

        this.$store.dispatch('userSignUpWithEmail', {
          email:    this.email,
          password: this.password,
          fullName: this.fullName
        })
      },
    },
    watch:      {}
  }
</script>

<style src="../Login/Login.scss" lang="scss" scoped/>
